import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import moment from 'moment';

class PendientesFacturar extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'Ventas', saveUrl: 'Ventas/save', backUrl: '/Catalogo' },
      new Form([
        Form.Field('date', 'startDate', 'Fecha Inicial', '', [Validators.required], 6),
        Form.Field('date', 'endDate', 'Fecha Final', '', [Validators.required], 6),
        Form.Field('select', 'type', 'Tipo', '', [Validators.required], 6, [
          { Label: 'Credito', Value: '1' },
          { Label: 'Contado', Value: '2' },
        ]),
        Form.Field('select', 'id_sucursal', 'Sucursal', '', [Validators.required], 6, []),
      ], ['Descargar Excel'], 'Guias pendientes de Facturar'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  formData = async (form) => {
    var Res = await Http.get('sucursal/all');

    if (!Res.error) {
      const data = [
        { id: 0, sucursal_nombre: 'Todas'},
        ...Res.data
      ]
      const sucursales = Form.FieldOptions(form, 'id_sucursal', data, 'id', 'sucursal_nombre');
      return sucursales;
    }
  }


  onSubmit = async (i, vals) => {
    this.setState({ loading: true });
    const { startDate, endDate, id_sucursal, type } = vals;
    const start = moment(startDate).format('YYYY-MM-DD')
    const end = moment(endDate).format('YYYY-MM-DD')
    const Resp = await Http.get(`reporte/guias-no-facturadas?q=1&start_date=${start}&end_date=${end}&id_sucursal=${id_sucursal}&type=${type}`, true, 'arraybuffer')
    if (Resp) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
      const url = URL.createObjectURL(blob)

      const link = document.createElement('a');
      link.href = url;
      link.download = 'guias_no_facturadas.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(PendientesFacturar)
